module.exports = __webpack_public_path__ + "img/dz.925c0186.svg";